"use client"

import AboutContent from "@/app/components/AboutContent"
import { Banner } from "@/app/components/Banner"
import Process from "@/app/components/Processes"
import TeamMembers from "@/app/components/TeamMembers"
import { useTranslations } from "next-intl"


const About = () => {
  const t  = useTranslations()


  return (
    <>
      <Banner name={t('links.aboutUs')} className='bg-aboutBanner' />
      <AboutContent className='px-6 py-20  sm:px-14 md:px-16' />
      <Process className=" py-20"/>
      <div className='bg-primary bg-team bg-cover bg-no-repeat'>
        <TeamMembers className='pt-20 px-6 text-white sm:px-14 md:px-16' />
      </div>
    </>
  )
}

export default About
